<template>
  <demandActionButton
    :disabled="isDisabled"
    page="1"
    button1String="キャンセル"
    :button1Action="backPage"
    button2String="日付と人数 ＞"
    :button2Action="gotoBooking2"
  />
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "TheDemandActionButton1",
  props: {
    pickupStop: {
      type: Object,
      required: true,
    },
    dropoffStop: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const backPage = () => {
      router.push({
        name: "DemandIndex",
      });      
    }

    const gotoBooking2 = async() => {
      await store.commit("demand/setPickUpBusstopId", props.pickupStop.id);
      await store.commit("demand/setDropOffBusstopId", props.dropoffStop.id);

      router.push({
        name: "DemandEbusBooking2",
      });     
    }

    return{
      backPage,
      gotoBooking2,
    }
  }
};
</script>
